import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "download"
const DownloadIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M20.25 21.75H3.75V20.25H20.25z" />
          <path
            fillRule="evenodd"
            d="M15 9.75H19.67L12 18.379 4.33 9.75H9V2.25H15zM10.5 11.25H7.67L12 16.121 16.33 11.25H13.5V3.75H10.5z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default DownloadIcon
